module.exports = __webpack_public_path__ + "img/game.24e2a752.png";